import { ErrorView } from "components/ErrorView/ErrorView";
import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject, Navigate } from "react-router-dom";
const ProjectListPage = React.lazy(() => import("modules/MainModule/pages/ProjectListPage/ProjectListPage"));
const EditProjectPage = React.lazy(() => import("modules/MainModule/pages/EditProjectPage/EditProjectPage"));
const ProjectSurveysPage = React.lazy(
  () => import("modules/MainModule/pages/ProjectSurveysProgressPage/ProjectSurveysProgressPage"),
);

const HomeRedirectPage = React.lazy(
  () => import("modules/MainModule/pages/HomeRedirectPage/HomeRedirectPage"),
);
const CreatePage = React.lazy(() => import("modules/MainModule/pages/CreatePage/CreatePage"));
const AssistantLayout = React.lazy(() => import("modules/MainModule/pages/AssistantLayout/AssistantLayout"));
const AssistantPage = React.lazy(() => import("modules/MainModule/pages/AssistantPage/AssistantPage"));
const AssistantConversationPage = React.lazy(
  () => import("modules/MainModule/pages/AssistantConversationPage/AssistantConversationPage"),
);
const MainModule = React.lazy(() => import("./MainModule"));

const getProjectPageRoute = () => {
  const numbers = window.location.pathname.split("/").filter((a) => !!a && !isNaN(Number(a)));
  return `/${numbers[0]}/project/${numbers[1]}`;
};

export const MainModuleRoutes: RouteObject = {
  path: ":clientId/",
  element: <ModuleRoute El={MainModule} moduleName="main" blockWhenChurned />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "",
      element: <PageRoute El={HomeRedirectPage} />,
    },
    {
      path: "home",
      element: <PageRoute El={ProjectListPage} />,
    },
    {
      path: "create",
      element: <PageRoute El={CreatePage} inPolicy={"TeamUser"} />,
    },
    {
      path: "assistant",
      element: <PageRoute El={AssistantLayout} inPolicy={"TeamViewer"} ff={"Assistant"} blockWhenChurned />,
      children: [
        { index: true, element: <PageRoute El={AssistantPage} /> },
        { path: ":threadId", element: <PageRoute El={AssistantConversationPage} /> },
      ],
    },
    {
      path: "result/:projectId/:tab?/:questionId?",
      element: (
        <Navigate
          to={`${window.location.pathname.replace("/result/", "/results/")}${window.location.search}`}
        />
      ),
    },
    {
      path: "projects/*",
      element: <Navigate to={`${getProjectPageRoute()}${window.location.search}`} />,
    },
    {
      path: "project/:projectId/:tab?",
      element: <PageRoute El={EditProjectPage} inPolicy={"SharedViewerUser"} />,
    },
    {
      path: "project-surveys/:projectId",
      element: <PageRoute El={ProjectSurveysPage} inPolicy={"SharedViewerUser"} />,
    },
  ],
};
